(function () {
    var STORAGE_KEY = 'stoebermodus-active';
    var CACHE_KEY = 'stoebermodus-pages';
    var PREV_KEY = 'stoebermodus-prev';
    var floatingEl = null;


    function isActive() {
        try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
    }

    function activate() {
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        document.body.classList.add('stoebermodus-active');
        showFloating();
        nextPage();
    }

    function deactivate() {
        try {
            localStorage.removeItem(STORAGE_KEY);
            sessionStorage.removeItem(PREV_KEY);
        } catch (e) {}
        document.body.classList.remove('stoebermodus-active');
        hideFloating();
    }

    function getPages(callback) {
        try {
            var cached = sessionStorage.getItem(CACHE_KEY);
            if (cached) { callback(JSON.parse(cached)); return; }
        } catch (e) {}
        fetch('/assets/data/stoebermodus-pages.json')
            .then(function (r) { return r.json(); })
            .then(function (pages) {
                try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(pages)); } catch (e) {}
                callback(pages);
            })
            .catch(function () { callback([]); });
    }

    function nextPage() {
        getPages(function (pages) {
            var current = decodeURIComponent(window.location.pathname);
            var prev = '';
            try { prev = sessionStorage.getItem(PREV_KEY) || ''; } catch (e) {}
            var norm = function (p) { return p.replace(/\/$/, ''); };
            var filtered = pages.filter(function (p) {
                return norm(p) !== norm(current) && norm(p) !== norm(prev);
            });
            if (!filtered.length) filtered = pages.filter(function (p) { return norm(p) !== norm(current); });
            if (!filtered.length) filtered = pages;
            var url = filtered.length ? filtered[Math.floor(Math.random() * filtered.length)] : null;
            if (url) {
                try { sessionStorage.setItem(PREV_KEY, current); } catch (e) {}
                window.location.href = url;
            }
        });
    }

    function showModal() {
        if (document.querySelector('.stoeber-modal-overlay')) return;
        var overlay = document.createElement('div');
        overlay.className = 'stoeber-modal-overlay';
        overlay.innerHTML =
            '<div class="stoeber-modal">' +
                '<div class="stoeber-modal-icon">🎲</div>' +
                '<h2 class="stoeber-modal-title">Stöbermodus</h2>' +
                '<p class="stoeber-modal-desc">Springt zu einer zufälligen Seite. Der wahrscheinlich beste Weg, meine Website zu erkunden! :)</p>' +
                '<div class="stoeber-modal-actions">' +
                    '<button class="stoeber-modal-start">Starten</button>' +
                    '<button class="stoeber-modal-cancel">Abbrechen</button>' +
                '</div>' +
            '</div>';
        document.body.appendChild(overlay);

        overlay.querySelector('.stoeber-modal-start').addEventListener('click', function () {
            overlay.remove();
            activate();
        });
        overlay.querySelector('.stoeber-modal-cancel').addEventListener('click', function () {
            overlay.remove();
        });
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) overlay.remove();
        });
    }

    function showFloating() {
        if (floatingEl) return;
        floatingEl = document.createElement('div');
        floatingEl.className = 'stoeber-floating';

        var nextBtn = document.createElement('button');
        nextBtn.className = 'stoeber-next';
        nextBtn.textContent = '→ Nächste Seite';
        nextBtn.addEventListener('click', nextPage);

        var stopBtn = document.createElement('button');
        stopBtn.className = 'stoeber-stop';
        stopBtn.textContent = '✕ Beenden';
        stopBtn.addEventListener('click', deactivate);

        floatingEl.appendChild(nextBtn);
        floatingEl.appendChild(stopBtn);
        document.body.appendChild(floatingEl);
    }

    function hideFloating() {
        if (floatingEl) { floatingEl.remove(); floatingEl = null; }
    }

    window.startStoeber = showModal;

    if (isActive()) {
        document.body.classList.add('stoebermodus-active');
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', showFloating);
        } else {
            showFloating();
        }
    }
})();
